export default function ({ route, redirect }) {
  const path = route.path;
  if (!route.path.endsWith('/') && !path.includes('#') && route.path !== '/') {
    return redirect(301, `${path}/`);
  }
}
